export const trimLeadingSlash = (urlPath: string) => urlPath.replace(/^\//, '');
export const trimTrailingSlash = (urlPath: string) => urlPath.replace(/\/$/, '');
export const trimLeadingAndTrailingSlash = (urlPath: string) => trimTrailingSlash(trimLeadingSlash(urlPath));
